import { http } from '../plugins/http'
import { type AxiosResponse } from 'axios'

import Local from '@/types/Local'
import type PaginatedResponse from '@/types/PaginatedResponse'
import type DataResponse from '@/types/DataResponse'

export default class LocalService {
  async index(page: number, filters: string, per_page: number | undefined = 10): Promise<AxiosResponse<PaginatedResponse<Local>>> {
    return await http.get<PaginatedResponse<Local>>(`/api/v1/office/locations?page=${page}&${filters}&per_page=${per_page}`)
  }

  async show(id: string) {
    return await http.get<DataResponse<Local>>(`/api/v1/office/locations/${id}`)
  }

  async store(model: Local) {
    return await http.post<DataResponse<Local>>(`/api/v1/office/locations`, model)
  }

  async update(id: string, model: Local) {
    return await http.put<DataResponse<Local>>(`/api/v1/office/locations/${id}`, model)
  }

  async destroy(id: string) {
    return await http.delete(`/api/v1/office/locations/${id}`)
  }
}
